// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 14) return "static/js/072ceb51c11e65f0590a.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"7d78127fd85e8cbc8d4f","112":"af96e365276d78e55e23","113":"baf55a95b34336a64eee"}[chunkId] + ".chunk.js";
};